import { getLoginMutationHandler } from '~/hooks/mutations/get-login-mutation-handler.js';
import { getLogoutMutationHandler } from '~/hooks/mutations/get-logout-mutation-handler.js';
import { getRegistrationMutationHandler } from '~/hooks/mutations/get-registration-mutation-handler.js';
import { getResetPasswordRequestMutationHandler, getResetPasswordMutationHandler } from '~/hooks/mutations/get-reset-password-mutation-handler.js';

export async function submitRegistration({ firstName, lastName, email, password, captchaToken }) {
  const { mutationHandler: submitRegistration } = getRegistrationMutationHandler();

  try {
    return await submitRegistration({ firstName, lastName, email, password, captchaToken })
  } catch (error) {
    // @todo handle returned API errors
    return error
  }
}

export async function submitResetPasswordRequest({ username }) {
  const { mutationHandler: submitResetPasswordRequest } = getResetPasswordRequestMutationHandler();

  try {
    return await submitResetPasswordRequest({ username })
  } catch (error) {
    // @todo handle returned API errors
    return error
  }
}

export async function submitResetPassword({ login, password, key }) {
  const { mutationHandler: submitResetPassword } = getResetPasswordMutationHandler();

  try {
    return await submitResetPassword({ login, password, key })
  } catch (error) {
    return error
  }
}

export async function submitLogin({ login, password, captchaToken }) {
  const { mutationHandler: submitLogin } = getLoginMutationHandler();

  try {
    return await submitLogin({ login, password, captchaToken })
  } catch (error) {
    return undefined;
  }
}

export async function submitLogout() {
  const { mutationHandler: submitLogout } = getLogoutMutationHandler()

  return await submitLogout()
}
